import React from 'react'
import { Container, Card, SectionHeading, ButtonLink } from '../components/atoms.jsx'
import { SeoManager } from '../components/content.jsx'

export function ForbiddenPage() {
  return (
    <>
      <SeoManager
        title="403 · Adgang nægtet | Helseklinikken"
        description="Du har ikke adgang til denne side."
        canonical="https://helselarsen.dk/403/"
      />
      <main className="py-16 lg:py-24">
        <Container>
          <Card className="mx-auto max-w-2xl space-y-6 text-center">
            <SectionHeading eyebrow="403" title="Adgang nægtet" description="Du har ikke adgang til denne side." align="center" />
            <ButtonLink href="/" variant="primary">Til forsiden</ButtonLink>
          </Card>
        </Container>
      </main>
    </>
  )
}
